<template>
  <v-sheet elevation="0" width="100%" class="pa-3" style="margin-bottom: 1px; background-color: #CFD8DC;">
    <v-row style="padding-left:10px;text-align:center;" >
      <v-overlay :value="overlay">
        <div style="width:1024px;">
          <v-img
            :src="getFileName()"
            opacity="0.96"
            style="max-width:1024px;"
            @click="onAttachmentClicked"
          >
          </v-img>
        </div>
      </v-overlay>

      <div style="width:100%">
        <div style="margin:0 auto;width:102px;padding:5px 10px 5px 10px;">
          <v-img
            :src="getThumbFileName()"
            style="max-width:102px;"
            @click="onAttachmentClicked"
          >
          </v-img>
        </div>
      </div>
    </v-row>

    <v-row>
      <div>
        <div style="padding-left:5px;">{{description.length > 0 ? description : 'no description'}}</div>
        <div style="padding-left:5px;">Created By: <b>{{createdBy}}</b></div>
        <div style="padding-left:5px;">Created At: <b>{{formatTime(createdAt)}}</b></div>
      </div>
    </v-row>

    <v-row>
      <v-spacer></v-spacer>
      <div style="padding:0 10px 10px 0;">
        <v-btn style="margin-right:10px;top:8px;" @click="onDownloadImg">Download</v-btn>
      </div>
    </v-row>
  </v-sheet>
</template>

<script>
import moment from "moment";

export default {
  props: {
    id: String,
    fileName: String,
    thumbFileName: String,
    description: String,
    createdAt: String,
    createdBy: String,
  },

  data() {
    return {
      overlay: false,
    };
  },

  methods: {
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },

    getFileName() {
      console.log(`---- image is ${this.fileName}`);
      return this.fileName;
    },

    getThumbFileName() {
      console.log(`---- thumbFileName is ${this.thumbFileName}`);
      return this.thumbFileName;
    },

    onAttachmentClicked() {
      console.log('attachment clicked...');
      this.overlay = !this.overlay;
    },

    onDownloadImg() {
      console.log(`fileName: ${this.fileName}`);
      console.log(`thumbFileName: ${this.thumbFileName}`);

      this.$http({
        method: 'get',
        url: this.getFileName(),
        responseType: 'arraybuffer',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const fileName = this.getFileName().replace(/^.*[\\\/]/, '');

          console.log(`filename will be: ${fileName}`);

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>
